import axios, { AxiosProgressEvent } from 'axios';
import { Common } from '../../common';
import {
  Configuration,
  ConfigurationWithPluginConfigs,
  UpsertValuesWithPluginConfigs,
} from '../../models/organization/assistant/configuration';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByOrganizationId(
    organizationId: string,
  ): Promise<ConfigurationWithPluginConfigs[]> {
    const url = this.common.constructPath(
      `/organizations/${organizationId}/assistant/configurations`,
    );
    return this.common.getJSON(url);
  }

  async findOneById(
    id: string,
    organizationId: string,
  ): Promise<ConfigurationWithPluginConfigs> {
    const url = this.common.constructPath(
      `/organizations/${organizationId}/assistant/configurations/${id}`,
    );
    return this.common.getJSON(url);
  }

  async create(
    organizationId: string,
    values: UpsertValuesWithPluginConfigs,
  ): Promise<ConfigurationWithPluginConfigs> {
    const url = this.common.constructPath(
      `/organizations/${organizationId}/assistant/configurations`,
    );
    return this.common.postJSON(url, values);
  }

  async update(
    id: string,
    organizationId: string,
    values: UpsertValuesWithPluginConfigs,
  ): Promise<ConfigurationWithPluginConfigs> {
    const url = this.common.constructPath(
      `/organizations/${organizationId}/assistant/configurations/${id}`,
    );
    return this.common.patchJSON(url, values);
  }

  async remove(
    id: string,
    organizationId: string,
  ): Promise<{ success: boolean }> {
    const url = this.common.constructPath(
      `/organizations/${organizationId}/assistant/configurations/${id}`,
    );
    return this.common.deleteJSON(url);
  }

  async getSignedUploadURL(
    organizationId: string,
    attribute: keyof Configuration,
  ): Promise<{ url: string }> {
    const url = this.common.constructPath(
      `/organizations/${organizationId}/assistant/configurations/signed-url`,
    );
    return this.common.postJSON(url, { attribute });
  }

  async upload(
    file: File,
    signedUploadURL: string,
    onUploadProgress: (event: AxiosProgressEvent) => void,
  ): Promise<number> {
    const response = await axios.put(signedUploadURL, file, {
      onUploadProgress,
      headers: { 'Content-Type': 'image/png' },
    });
    return response.status;
  }
}
